export enum CreatePropertyOptions {
  MIGRATE_ARI = "MIGRATE_ARI",
  MIGRATE_INVENTORY = "MIGRATE_INVENTORY",
}

export interface CreatePropertyEntity {
  id: string;
  originPropertyTicker: string;
  targetPropertyTicker: string;
  options: CreatePropertyOptions[];
}

export interface CreatePropertyRequestDto {
  toDevel: boolean;
  originPropertyTicker: string;
  targetPropertyTicker: string;
  emails?: string[];
  options: {
    migrateInventory: boolean;
    migrateAri: boolean;
  };
}
